/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Legacy_Close_Track2_Aria_LabelInputs */

const en_timeline_legacy_close_track2_aria_label = /** @type {(inputs: Timeline_Legacy_Close_Track2_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close Track 2`)
};

const fr_timeline_legacy_close_track2_aria_label = /** @type {(inputs: Timeline_Legacy_Close_Track2_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer la piste 2`)
};

const de_timeline_legacy_close_track2_aria_label = /** @type {(inputs: Timeline_Legacy_Close_Track2_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gleis 2 schließen`)
};

const it_timeline_legacy_close_track2_aria_label = /** @type {(inputs: Timeline_Legacy_Close_Track2_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi Traccia 2`)
};

const ru_timeline_legacy_close_track2_aria_label = /** @type {(inputs: Timeline_Legacy_Close_Track2_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть трек 2`)
};

const es_timeline_legacy_close_track2_aria_label = /** @type {(inputs: Timeline_Legacy_Close_Track2_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar pista 2`)
};

const zh_cn2_timeline_legacy_close_track2_aria_label = /** @type {(inputs: Timeline_Legacy_Close_Track2_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭轨道 2`)
};

const ja_timeline_legacy_close_track2_aria_label = /** @type {(inputs: Timeline_Legacy_Close_Track2_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トラック2を閉じる`)
};

const hi_timeline_legacy_close_track2_aria_label = /** @type {(inputs: Timeline_Legacy_Close_Track2_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्रैक 2 बंद करें`)
};

const pt_pt2_timeline_legacy_close_track2_aria_label = /** @type {(inputs: Timeline_Legacy_Close_Track2_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar Faixa 2`)
};

/**
* | output |
* | --- |
* | "Close Track 2" |
*
* @param {Timeline_Legacy_Close_Track2_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_legacy_close_track2_aria_label = /** @type {((inputs?: Timeline_Legacy_Close_Track2_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Legacy_Close_Track2_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timeline_legacy_close_track2_aria_label(inputs)
	if (locale === "de") return de_timeline_legacy_close_track2_aria_label(inputs)
	if (locale === "it") return it_timeline_legacy_close_track2_aria_label(inputs)
	if (locale === "ru") return ru_timeline_legacy_close_track2_aria_label(inputs)
	if (locale === "es") return es_timeline_legacy_close_track2_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_timeline_legacy_close_track2_aria_label(inputs)
	if (locale === "ja") return ja_timeline_legacy_close_track2_aria_label(inputs)
	if (locale === "hi") return hi_timeline_legacy_close_track2_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_timeline_legacy_close_track2_aria_label(inputs)
	return en_timeline_legacy_close_track2_aria_label(inputs)
});